import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 26, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.7, delay, ease: [0.21, 0.65, 0.16, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
